export var TYPOGRAPHY_VARIANTS = [
    "headline",
    "title1",
    "title2",
    "title3",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "body3",
    "button",
    "caption",
    "caption2",
    "overline",
];
export var TYPOGRAPHY_WEIGHTS = ["normal", "medium", "semibold", "bold"];
export var TYPOGRAPHY_LEADINGS = [
    "none",
    "tighter",
    "tight",
    "tighty",
    "snug",
    "normal",
    "relaxed",
    "loose",
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
];
export var TYPOGRAPHY_TRACKINGS = [
    "tighter",
    "tight",
    "normal",
    "wide",
    "wider",
    "widest",
    1,
    "1.25",
    2,
    3,
    4,
];
//# sourceMappingURL=constants.js.map